<template>
  <div class="hallOfFameWrap">
    <div class="mainCom w1200 clearfix">
      <div class="mainComL">
        <menuWX></menuWX>
      </div>
      <div class="mainComR">
        <div class="hallOfFameBar">
          <div class="title"><img :src="title" alt=""></div>
          <div class="hallOfFameMain">
            <div class="hallOfFameCon">
              <div class="hallOfFameMain">
                <div class="tableWrap">
                  <el-table style="width: 100%" stripe :data="tableData">
                    <template v-for="(item, index) in tableHead[0]">
                      <el-table-column :prop="item.prop" :label="item.label" :width="item.width"></el-table-column>
                      <!--:min-width="(index==1 || index==2 || index==3 || index==4)?110:0"-->
                    </template>
                  </el-table>
                  <div class="pageWrap txtC">
                    <el-pagination background layout="total, prev, pager, next, jumper" :current-page="page"
                      :page-size="size" :total="total" @current-change="handleCurrentChange">
                    </el-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="illustrateWrap">
          <div class="tit">规则说明：</div>
          <div class="cons">
            <p>1）结算时登顶排行榜第一的玩家将被录入相应名人堂。</p>
            <p>2）充值排行榜结算周期为周一0点到周日24点</p>
            <p>3）充值名人堂更新时间为周一上午8点。</p>
            <p>4）天梯名人以及赛季名人将在后续赛季模式开始后记录数据，详情留意官网后续版本计划。</p>
            <p>5）名人堂相关数据永久保留展示。</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import menuWX from '../../components/Menu/index.vue'
import axios from "axios";
import Cookies from "js-cookie";
import { getFamousRankApi } from '@/api/hallOfFame/index.js' //名人堂

export default {
  name: 'record',
  components: {
    menuWX,
  },
  data() {
    return {
      title: require('@/assets/imgs/hallOfFame/title.png'),
      page: 1,
      size: 10,
      total: 0,
      tableHead: [
        [
          { prop: 'periodName', label: '期数', },
          { prop: 'tab0', label: '充值名人', },
          { prop: 'tab1', label: '天梯名人', },
          { prop: 'tab2', label: '赛季名人', },
          // { prop: 'tab3', label: '普通公告名人', width: '128px' },
          // { prop: 'tab4', label: '赠花名人', },
          // { prop: 'tab5', label: '魅力名人', },
          // { prop: 'tab6', label: '充值名人', },
        ],
      ],
      tableData: [],
    }
  },
  created() {
    this.getHallFameData()
  },
  mounted() {
    document.documentElement.scrollTop = 0
  },
  methods: {
    getHallFameData() {

      getFamousRankApi({
        type: 1,
        pageNum: this.page,
        pageSize: this.size,
        userId: Cookies.get('cwsl_userId'),
        platForm: 'web',
      }).then((res) => {
        if (res.data.state == 200) {
          // console.log(res.data);
          this.total = res.data.data.counts
          this.tableData = res.data.data.famousResponses.map((item, index) => {
            let obj = {}
            obj.periodName = item.periodName
            item.usernickInfo.forEach((item2, index2) => {
              obj['tab' + index2] = item2
            })
            return obj
          })
        } else {
          this.$message.error(res.data.message)
        }
      }).catch(err => {
        this.$message.error(err.message)
      })
    },                // 获取名人堂数据
    handleCurrentChange(val) {
      this.page = val
      this.getHallFameData()
    },
  }
}
</script>

<style lang="less">
.hallOfFameWrap {
  .hallOfFameMain {
    .el-table {
      width: 100%;
      background: none;
      border: 1px solid #734E00;

      &::before {
        background: none;
      }

      .el-table__cell {
        border: none;
      }

      tr {
        border: none;
        background: none;

        .cell {
          text-align: center;
        }

        th {
          padding: 0;
          height: 60px;
          line-height: 60px;
          background: #734E00;

          .cell {
            color: #ffffff;
            font-size: 18px;
            white-space: nowrap;
          }
        }

        td {
          padding: 0;
          height: 50px;
          line-height: 50px;

          .cell {
            font-size: 14px;
          }
        }

        &:hover {
          .el-table__cell {
            background: none;
          }

          th.el-table__cell {
            background: #734E00;
          }
        }
      }

      .el-table__row--striped {
        td.el-table__cell {
          background: #734E001A;
          border: none;
        }
      }
    }
  }
}
</style>
<style lang="less" scoped>
.hallOfFameWrap {
  padding-bottom: 20px;
  margin-top: 150px;

  .hallOfFameBar {
    background: url('../../assets//imgs/hallOfFame/hallOfFame.png');
    background-size: 100% 100%;

    .title {
      transform: translateY(20px);
      text-align: center;
    }

    .hallOfFameMain {
      .hallOfFameCon {
        margin-bottom: 20px;
        padding: 10px 13px;
        border-radius: 5px;
        ;
        // background: linear-gradient(to bottom, #8D9CFF, #5768FE);
        box-shadow: 0px 2px 8px 0px #EED9FF, 0px 0px 4px 0px rgba(255, 255, 255, 0.25);

        .hallOfFameMain {
          padding: 17px;
          border-radius: 5px;
          // background: linear-gradient(to bottom, #F6F6FF, #BAC0FF);
        }
      }

      .pageWrap {
        padding-top: 20px;
      }
    }


  }

  .illustrateWrap {
    padding: 16px 30px 30px;
    background: #ffffff;
    box-shadow: 0px 2px 8px 0px #EED9FF, 0px 0px 4px 0px rgba(255, 255, 255, 0.25);

    .tit {
      margin-bottom: 8px;
      font-size: 20px;
      font-weight: 500;
      color: #333333;
      line-height: 23px;
    }

    .cons {
      padding: 20px;
      background: #734E001A;
      border-radius: 10px;
      line-height: 30px;

      p {
        font-size: 16px;
      }
    }
  }
}
</style>
